import * as React from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;       // controls icon color
  selected?: boolean;   // optional selected state
}

export const ListIcon: React.FC<IconProps> = ({
  size = 16,
  color,
  selected,
  ...props
}) => {
  

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={props["aria-label"] ? undefined : true}
      {...props}
    >
      <g clipPath="url(#clip0_5598_5923)">
        <path
          d="M4.66667 5.64144V4.30811H14V5.64144H4.66667ZM4.66667 8.30811V6.97477H14V8.30811H4.66667ZM4.66667 10.9748V9.64144H14V10.9748H4.66667ZM2.66667 5.64144C2.47778 5.64144 2.31944 5.57755 2.19167 5.44977C2.06389 5.32199 2 5.16366 2 4.97477C2 4.78588 2.06389 4.62755 2.19167 4.49977C2.31944 4.37199 2.47778 4.30811 2.66667 4.30811C2.85556 4.30811 3.01389 4.37199 3.14167 4.49977C3.26944 4.62755 3.33333 4.78588 3.33333 4.97477C3.33333 5.16366 3.26944 5.32199 3.14167 5.44977C3.01389 5.57755 2.85556 5.64144 2.66667 5.64144ZM2.66667 8.30811C2.47778 8.30811 2.31944 8.24422 2.19167 8.11644C2.06389 7.98866 2 7.83033 2 7.64144C2 7.45255 2.06389 7.29422 2.19167 7.16644C2.31944 7.03866 2.47778 6.97477 2.66667 6.97477C2.85556 6.97477 3.01389 7.03866 3.14167 7.16644C3.26944 7.29422 3.33333 7.45255 3.33333 7.64144C3.33333 7.83033 3.26944 7.98866 3.14167 8.11644C3.01389 8.24422 2.85556 8.30811 2.66667 8.30811ZM2.66667 10.9748C2.47778 10.9748 2.31944 10.9109 2.19167 10.7831C2.06389 10.6553 2 10.497 2 10.3081C2 10.1192 2.06389 9.96088 2.19167 9.83311C2.31944 9.70533 2.47778 9.64144 2.66667 9.64144C2.85556 9.64144 3.01389 9.70533 3.14167 9.83311C3.26944 9.96088 3.33333 10.1192 3.33333 10.3081C3.33333 10.497 3.26944 10.6553 3.14167 10.7831C3.01389 10.9109 2.85556 10.9748 2.66667 10.9748Z"
          fill={color || "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5598_5923">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ListIcon;
